import { accordionBlueprint } from "@made-people/blueprint-accordion/blueprint";

accordionBlueprint.override({
  slots: {
    base: "",
    trigger:
      "flex items-center justify-start w-full py-4 cursor-pointer group/facet-trigger text-label-md lg:text-label-lg font-medium lg:font-medium text-left gap-4",
    icon: "w-12 h-12 rounded-full overflow-hidden bg-white",
    content: "pb-3",
    item: "border-b border-beige-100 first:border-t",
    header: "",
    headerWrapper: "flex items-center gap-2 pb-2 lg:pb-4",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:hidden size-3 min-w-3 ml-auto",
    iconClose: "group-data-[state=closed]:hidden size-3 min-w-3 ml-auto",
  },
});
